const React = require('react');
const { string, arrayOf, shape } = require('prop-types');

const { FILTERS_IDS } = require('@pages/V2/utils/constants');

const { buildUrl } = require('@pages/V2/utils/clientUtils');

const { Card } = require('@andes/card');
const { Switch } = require('@andes/switch');
const Full = require('@pages/V2/icons/full');

function renderIconSwitch(id) {
  switch (id) {
    case FILTERS_IDS.SHIPPING:
      return <Full className="full-icon" />;
    default:
      return undefined;
  }
}

const getSubtitle = (id, translations) => {
  switch (id) {
    case FILTERS_IDS.SHIPPING:
      return translations.shipping || '';
    default:
      return '';
  }
};

const getSwitchTitle = (id, translations, defaultTitle = '') => {
  switch (id) {
    case FILTERS_IDS.SHIPPING:
      return translations.shippingTitle || '';
    default:
      return defaultTitle;
  }
};

function SwitchFilter({ id, name, values, actualLocation, appliedFilters, filterPosition, translations }) {
  const labelSubtitle = getSubtitle(id, translations);
  const valueId = values[0] && values[0].id;
  const valueName = getSwitchTitle(id, translations, values[0] && values[0].name);
  const checked = appliedFilters.find((filter) => filter.id === id);

  const onChangeSwitch = (switchValue) => {
    const url = buildUrl({
      actualLocation,
      filterId: id,
      filterValueId: valueId,
      addQueryParam: switchValue,
      filterPosition,
    });
    if (typeof document !== 'undefined') document.location.href = url;
  };

  return (
    valueId && (
      <Card className="switch-filter">
        <div className="switch-filter__content-box">
          <span className="switch-filter__title">
            {renderIconSwitch(id)}
            {valueName}
          </span>
          {labelSubtitle && <span className="switch-filter__subtitle">{labelSubtitle}</span>}
        </div>

        <Switch
          className="switch-filter__switch-box"
          onChange={(e) => onChangeSwitch(e.target.checked)}
          srLabel={name}
          defaultChecked={checked}
        />
      </Card>
    )
  );
}

SwitchFilter.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  values: arrayOf(shape({ id: string, name: string })),
  actualLocation: string,
};

SwitchFilter.defaultProps = {
  values: [],
  actualLocation: '',
};

module.exports = SwitchFilter;
